import React from 'react';
import {useAuthenticator} from '@aws-amplify/ui-react';
import MortgageProvider from "../contexts/MortgageProvider";
import {Navigate, useLocation} from "react-router-dom";
import ClientAppDashboard from "./ClientAppDashboard";
export default function AuthedClientApp(props) {
    const {user, signOut} = useAuthenticator((context) => [context.user]);
    const loc = useLocation()

    if (!user) {
        return <Navigate to={'/login?path=' + loc.pathname}/>
    }
    //redirect if a supporter or admin
    let payload = user.signInUserSession.accessToken.payload
    if (payload.hasOwnProperty("cognito:groups") && payload["cognito:groups"].includes("admins")) {
        window.location.href='https://admin.sussd.ie'
    }
    return (

        <MortgageProvider user={user} >
            <ClientAppDashboard signOut={signOut}/>
        </MortgageProvider>

    )
}